<template>
  <div class="ProductService">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="cont_type">
      <ul class="typeList">
        <li :class="[item.key === componentTag.key ? 'on' : '', 'option']" v-for="item in pnavList" :key="item.key"
            @click="OnCurtype(item)">
          <router-link class="nuxtLink" :to="'/productService?key=' + item.key" :key="item.key">
            {{ item.lable }}
          </router-link>
        </li>
      </ul>
    </div>
    <transition mode="out-in">
      <component :is="componentTag.key" :key="componentTag.key"></component>
    </transition>
  </div>
</template>
<script>
import PageBanner from "@/components/common/pageBanner"
import Zhuanxiangtongji from "../components/ProductService/zhuanxiangtongji.vue"
import Sheqingminyi from "../components/ProductService/sheqingminyi.vue"
import Tongjibaobiao from "../components/ProductService/tongjibaobiao.vue"
import Jishuzixun from "../components/ProductService/jishuzixun.vue"
export default {
  name: "ProductService",
  metaInfo () {
    return {
      title: "产品服务",
      meta: [
        { name: "keywords", content: "广州统计师事务所" },
        { name: "description", content: "广州统计师事务所" },
      ],
    }
  },
  data () {
    return {
      bannerObj: {
        lableZh: "产品服务",
        lableEn: "PRODUCT SERVICE",
        bannerImg: require("@/assets/img/productService/banner.png"),
      },
      // 服务类型
      pnavList: [
        {
          lable: "专项统计与统计数据咨询",
          key: "Zhuanxiangtongji",
        },
        {
          lable: "社情民意调查研究",
          key: "Sheqingminyi",
        },
        {
          lable: "统计报表代填代报",
          key: "Tongjibaobiao",
        },
        {
          lable: "技术咨询",
          key: "Jishuzixun",
        },
      ],
      componentTag: {
        lable: "专项统计与统计数据咨询",
        key: "Zhuanxiangtongji",
      },
    }
  },
  methods: {
    // 选择服务类型
    OnCurtype (val) {
      console.log(val)
    },
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler (newVal, oldval) {
        if (newVal != oldval && newVal.query.key) {
          let resList = this.pnavList.filter((item) => {
            // console.log(newVal.query.key);
            // console.log(item.key);
            return newVal.query.key === item.key
          })
          this.componentTag = resList[0]
          // this.$nextTick(() => {
          //   this.$refs.cBanner.reInitBanner();
          // });
        }
      },
      immediate: true,
    },
  },
  components: {
    PageBanner,
    Zhuanxiangtongji,
    Sheqingminyi,
    Tongjibaobiao,
    Jishuzixun,
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.ProductService {
  width: 100%;
  min-width: $themeMinWidth;
  box-sizing: border-box;
  padding: 0 0 50px 0;
  .cont_type {
    width: $themeMinWidth;
    margin: 0 auto;
    .typeList {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 40px 0 30px;
      .option {
        width: 278px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #ffffff;
        border: solid 1px #e5e5e5;
        font-size: 16px;
        color: #333333;
        // margin: 0 20px 0 0;
        cursor: pointer;
        &:hover,
        &.on {
          background-color: #406cdd;
          color: #ffffff;
        }
        a {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
</style>
